/**
 * Check if the origin is a known and trusted login origin
 * @param {String} origin 
 * @returns Boolean
 */
export function isTrustedLoginOrigin(origin) {
  const trustedOriginHosts = [
    "https://login.amiratutor.com",
    "https://sso.us-east-1.rosterstream.com",
    "https://secure.dev2.istation.com",
    "https://secure.istation.com",
  ];

  const url = new URL(origin);
  return trustedOriginHosts.includes(url.origin);
}

/**
 * Redirect to the login origin if it is a trusted origin, clears the login origin from local storage and redirects.
 * @param {URLSearchParams} urlParams - used in the refresh to logout only
 * @param {Boolean} shouldGoToSessionEndedPage - used in the logout button only
 */
export function redirectToLoginOrigin(urlParams, shouldGoToSessionEndedPage = false) {
  
  // do not redirect if there is login origin in the url, this is to prevent redirect loop.
  if (urlParams && urlParams.get("login_origin")) {
    return;
  }

  try {
    const loginOrigin = localStorage.getItem("loginOrigin");
    if (loginOrigin && isTrustedLoginOrigin(loginOrigin)) {
      localStorage.removeItem("loginOrigin");
      window.location.href = loginOrigin;
    } else if ( shouldGoToSessionEndedPage ){
      window.location.href = "/sessionEnded.html";
    }
  } catch (e) {
    console.error("Error redirecting to login origin:", e);
  }
}

/**
 * Save the login origin to local storage so we can redirect back to it after refresh
 */
export function saveLoginOrigin(loginOrigin) {
  if (loginOrigin) {
    localStorage.setItem("loginOrigin", loginOrigin);
  }
}
